<template>
    <v-app id="inspire">
        <v-card>

            <v-card>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color3" :content="cantidad3" overlap>
                                <v-btn to="/LanzamientoListadoOC/">
                                    Comercial (Ingreso O.C.)
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color4" :content="cantidad4" overlap>
                                <v-btn to="/LanzamientoListadoEjecucionC/">
                                    Materiales
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color5" :content="cantidad5" overlap>
                                <v-btn to="/LanzamientoListadoEjecucionO/">
                                    Ing. de Obra / Obra
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color6" :content="cantidad6" overlap>
                                <v-btn to="/LanzamientoListadoEjecucionF/">
                                    Ing. de Prod. / Fabric.
                                </v-btn>
                            </v-badge>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>

                    <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color7" :content="cantidad7" overlap>
                                <v-btn to="/LanzamientoListadoCalidad/">
                                    Inspección y Ensayos
                                </v-btn>
                            </v-badge>
                        </v-col>

                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color8" :content="cantidad8" overlap>
                                <v-btn to="/LanzamientoListadoDespachoC/">
                                    Despacho Materiales
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color9" :content="cantidad9" overlap>
                                <v-btn to="/LanzamientoListadoDespachoO/">
                                    Despacho Ing. Obra
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color10" :content="cantidad10" overlap>
                                <v-btn to="/LanzamientoListadoDespachoF/">
                                    Despacho Ing.Prod./Fabr.
                                </v-btn>
                            </v-badge>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color11" :content="cantidad11" overlap>
                                <v-btn to="/LanzamientoListadoComercial/">
                                    Comercial
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color12" :content="cantidad12" overlap>
                                <v-btn to="/LanzamientoListadoAbastecimiento/">
                                    Abastecimiento
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color13" :content="cantidad13" overlap>
                                <v-btn to="/LanzamientoListadoAdministracion/">
                                    Administración
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color14" :content="cantidad14" overlap>
                                <v-btn to="/LanzamientoListadoCierre/">
                                    Cierre
                                </v-btn>
                            </v-badge>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row dense>
                        <v-col cols="6" sm="3" md="3">
                            <v-badge bordered :color="color1" :content="cantidad1" overlap>
                                <v-btn to="/LanzamientoAlerta/">
                                    Alertas
                                </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-btn to="/LanzamientoEstadisticaAlerta/">
                                Estadísticas Alertas
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-btn to="/LanzamientoListado">
                                Listado Completo
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">

                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
    </v-app>
</template>

<style scoped>
.v-btn:not(.v-btn--round).v-size--default {
    height: 30px;
    width: 300px;
    padding: 3px 8px;
}
</style>
<script>

import axios from "../../axios-auth";
import moment from "moment";

export default {
    data: () => ({
        cards: [
            {
                title: "Medio Ambiente",
                src: "images/medioambiente.jpg",
                flex: 4,
            },
            { title: "Recursos Humanos", src: "images/rrhh.jpg", flex: 4 },
            { title: "Hábitos Saludables", src: "images/habito.jpg", flex: 4 },
        ],
        accidentes: "",
        dias: null,
        usuario: null,
        dolar: "",
        euro: "",
        now: moment(),
        diferencia: "",
        showInforme: false,
        link: "",
        color1: "",
        color2: "",
        color3: "",
        color4: "",
        color5: "",
        color6: "",
        color7: "",
        color8: "",
        color9: "",
        color10: "",
        color11: "",
        color12: "",
        color13: "",
        color14: "",
        cantidad1: "",
        cantidad2: "",
        cantidad3: "",
        cantidad4: "",
        cantidad5: "",
        cantidad6: "",
        cantidad7: "",
        cantidad8: "",
        cantidad9: "",
        cantidad10: "",
        cantidad11: "",
        cantidad12: "",
        cantidad13: "",
        cantidad14: "",
    }),
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "ICSSA";
            this.cargarlanzamiento();
            console.log("mounted")
        }
    },
    methods: {
        cargarlanzamiento() {
            let self = this;
            axios
                .get("/Lanzamiento/Cargarvalores", {})
                .then(function (response) {

                    self.color1 = response.data.color1;
                    self.color2 = response.data.color2;
                    self.color3 = response.data.color3;
                    self.color4 = response.data.color4;
                    self.color5 = response.data.color5;
                    self.color6 = response.data.color6;
                    self.color7 = response.data.color7;
                    self.color8 = response.data.color8;
                    self.color9 = response.data.color9;
                    self.color10 = response.data.color10;
                    self.color11 = response.data.color11;
                    self.color12 = response.data.color12;
                    self.color13 = response.data.color13;
                    self.color14 = response.data.color14;
                    self.cantidad1 = response.data.cantidad1;
                    self.cantidad2 = response.data.cantidad2;
                    self.cantidad3 = response.data.cantidad3;
                    self.cantidad4 = response.data.cantidad4;
                    self.cantidad5 = response.data.cantidad5;
                    self.cantidad6 = response.data.cantidad6;
                    self.cantidad7 = response.data.cantidad7;
                    self.cantidad8 = response.data.cantidad8;
                    self.cantidad9 = response.data.cantidad9;
                    self.cantidad10 = response.data.cantidad10;
                    self.cantidad11 = response.data.cantidad11;
                    self.cantidad12 = response.data.cantidad12;
                    self.cantidad13 = response.data.cantidad13;
                    self.cantidad14 = response.data.cantidad14;
                    console.log(response.data)
                })
                .catch(function (error) { });

        },
    },
};
</script>